import { FC } from "react";

import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { toDefaultDateFormat } from "@/helpers/dates";
import { MyCalendarEvent } from "@/modules/myCalendar/myCalendar.types";
import { ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";

interface Props {
  events: Array<MyCalendarEvent>;
}

export const MyCalendarList: FC<Props> = ({ events }) => (
  <>
    <div className="w-full">
      <div className="relative overflow-hidden rounded-xl border bg-white shadow-sm">
        <div className="overflow-x-auto">
          <Table className="main-w-full divide-y divide-gray-300 rounded-lg">
            <TableHeader>
              <TableRow className="rounded-t-xl">
                <TableHead className="divide-y divide-gray-300 bg-gray-50/80">Date</TableHead>
                <TableHead className="max-w-[50%] divide-y divide-gray-300 bg-gray-50/80">Quote</TableHead>
                <TableHead className="min-w-[10rem] max-w-[50%] divide-y divide-gray-300 bg-gray-50/80">
                  Outlook event link
                </TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {events.length > 0 ? (
                events.map(item => (
                  <TableRow key={item.id}>
                    <TableCell>
                      <span className="text-xs">{toDefaultDateFormat(new Date(item.datetime).toISOString())}</span>
                    </TableCell>
                    <TableCell className="flex flex-col gap-1">
                      <div className="text-base font-bold">{item.title}</div>
                      <div>{item.summary}</div>
                    </TableCell>
                    <TableCell
                      className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6"
                      valign="top"
                    >
                      <Button variant="secondary" size="sm" className="mx-1 w-full text-xs sm:w-auto">
                        <a target="_blank" href={item.link} className="flex justify-center">
                          <ExternalLink className="mr-1 h-3 w-3" />
                        </a>
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4} className="h-24 text-center text-muted-foreground">
                    No event was found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  </>
);
